(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const init = root => {
    if (root.dataset.helpReady) return;
    root.dataset.helpReady = 'true';
    const search = root.querySelector('[data-help-search]');
    const input = search.querySelector('input');
    const clear = root.querySelector('[data-help-clear]');
    const empty = root.querySelector('[data-help-empty]');
    const questions = [...root.querySelectorAll('[data-help-question]')];
    const groups = [...root.querySelectorAll('[data-help-group]')];
    const index = questions.map(element => ({element, text: normalize(element.textContent)}));
    const update = () => {
      const words = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
      let count = 0;
      index.forEach(({element, text}) => {
        const matches = words.every(word => text.includes(word));
        element.hidden = !matches;
        if (words.length) element.open = matches;
        if (matches) count++;
      });
      groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-help-question]')].some(el => !el.hidden); });
      empty.hidden = count > 0;
      clear.hidden = words.length === 0;
    };
    input.addEventListener('input', update);
    clear.addEventListener('click', () => { input.value = ''; questions.forEach(el => el.open = false); update(); input.focus(); });
    root.querySelectorAll('.qs-help-nav a').forEach(link => link.addEventListener('click', () => {
      input.value = ''; questions.forEach(el => el.open = false); update();
    }));
    search.hidden = false;
  };
  document.querySelectorAll('[data-qs-help]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-qs-help]').forEach(init));
})();
